class i4_Edit_button {
	constructor(element) {
		this.$element = $(element);

		this.data = {
			pluginName: 'plugin-name',
			call: 'call',
			instanceID: 'instance-id',
			containerID: 'container-id',
			ajaxParameter: 'ajax-parameter'
		};
	}

	init() {

		this.dataPlugin = this.$element.data(this.data.pluginName);
		this.dataCall = this.$element.data(this.data.call);
		this.dataInstanceID = this.$element.data(this.data.instanceID);
		this.dataContainerID = this.$element.data(this.data.containerID);
		this.dataAjaxParameter = this.$element.data(this.data.ajaxParameter);

		this.$element.on('click', this.$elementClick.bind(this));

		// console.log('i4_Edit_button init()');
	}

	$elementClick() {
		i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});

		let ajaxParam = {
			js: this.dataPlugin,
			call: this.dataCall,
			instance_id: this.dataInstanceID,
			container_id: this.dataContainerID
		};

		ajaxParam = Object.assign(ajaxParam, this.dataAjaxParameter);

		// console.log('ajaxParam', ajaxParam);

		i4_Popup.add().set_option({
			ajax_param: ajaxParam,
			position: 'cursor',
			loader: true
		}).run();
	}
}

i4_Decorator_loader.registerClass('i4_Edit_button', i4_Edit_button);
